import React from 'react';
import { motion } from 'framer-motion';
import { Factory, Laptop, Globe, Wheat, Heart, Building } from 'lucide-react';
const clientTypes = [{
  icon: <Factory size={32} strokeWidth={1.5} data-id="element-46" />,
  title: 'Виробництво',
  description: 'ТОВ з виробничим циклом, складський облік'
}, {
  icon: <Laptop size={32} strokeWidth={1.5} data-id="element-47" />,
  title: 'ІТ та Дія Сіті',
  description: 'Резиденти, міжнародні контракти, Payoneer'
}, {
  icon: <Globe size={32} strokeWidth={1.5} data-id="element-48" />,
  title: 'ЗЕД',
  description: 'Експорт/імпорт, валютні операції'
}, {
  icon: <Wheat size={32} strokeWidth={1.5} data-id="element-49" />,
  title: 'Фермерські господарства',
  description: 'Специфіка агрообліку'
}, {
  icon: <Heart size={32} strokeWidth={1.5} data-id="element-50" />,
  title: 'Громадський сектор',
  description: 'БФ, БО, ГО — облік грантів і звітність'
}, {
  icon: <Building size={32} strokeWidth={1.5} data-id="element-51" />,
  title: 'ТОВ будь-якого профілю',
  description: 'Загальна та спрощена система, з/без ПДВ'
}];
export function Clients() {
  return <section id="clients" className="py-24 bg-surface" data-id="element-52">
      <div className="max-w-7xl mx-auto px-6" data-id="element-53">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-55">
            Хто наші клієнти
          </h2>
          <p className="text-secondary text-lg" data-id="element-56">
            Працюємо з бізнесом будь-якого масштабу та напрямку
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-57">
          {clientTypes.map((client, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-background p-8 rounded-3xl border border-border hover:border-primary/30 transition-colors duration-300 flex flex-col items-center text-center" data-id="element-58">
              <div className="w-16 h-16 bg-surface rounded-2xl flex items-center justify-center text-primary mb-6 border border-border" data-id="element-59">
                {client.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-60">{client.title}</h3>
              <p className="text-secondary text-sm leading-relaxed" data-id="element-61">
                {client.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}